var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('primary-button',{staticClass:"w-100 pt-2 pb-2",attrs:{"title":_vm.title,"centering":"true"},nativeOn:{"click":function($event){return _vm.next.apply(null, arguments)}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }